import { render, staticRenderFns } from "./TrcCard.vue?vue&type=template&id=a934a668&scoped=true"
import script from "./TrcCard.vue?vue&type=script&lang=js"
export * from "./TrcCard.vue?vue&type=script&lang=js"
import style0 from "./TrcCard.vue?vue&type=style&index=0&id=a934a668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a934a668",
  null
  
)

export default component.exports